import React from 'react';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              Expert <span className="title-accent">Consultancy</span> for Modern Business
            </h1>
            <p className="hero-description">
              Alium Software delivers world-class consultancy services in finance, healthcare, 
              and custom application development. We specialize in Azure cloud solutions and 
              help businesses transform digitally with confidence.
            </p>
            <div className="hero-buttons">
              <a href="#contact" className="btn btn-primary">Start Your Project</a>
              <a href="#services" className="btn btn-secondary">Our Services</a>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-card">
              <div className="card-content">
                <div className="hero-logo">
                  <img src="/logo512.png" alt="Alium Software - Innovation Blooms" className="hero-logo-image" />
                </div>
                <h3>Innovation Blooms</h3>
                <p>Where technology meets expertise</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;